import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/lib/auth';
import GoogleAuthSection from '@/components/auth/GoogleAuthSection';
import CustomerAuthLayout from '@/components/resqly/CustomerAuthLayout';
import AuthTutorialLink from '@/components/resqly/AuthTutorialLink';

export default function ConsumerLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const afterAuth = (data) => {
    login(data.token, 'consumer');
    toast.success('Welcome to Resqly');
    if (data.is_new || !data.user?.name) {
      navigate('/consumer/onboarding', { replace: true });
    } else {
      navigate('/consumer/home', { replace: true });
    }
  };

  // Do not gate the consumer website login by native-platform detection.
  // GoogleAuthSection selects the native Capacitor flow inside the app and
  // Google Identity Services for resqly.in in a regular browser.
  return (
    <CustomerAuthLayout>
      <div className="space-y-4">
        <GoogleAuthSection
          role="consumer"
          onAuthenticated={afterAuth}
          googleButtonTestId="consumer-google-signin"
          registerNameTestId="consumer-google-name"
          registerSubmitTestId="consumer-google-register"
        />
        <AuthTutorialLink />
      </div>
    </CustomerAuthLayout>
  );
}
